import { render, staticRenderFns } from "./noticeUserPop.vue?vue&type=template&id=4e8c12f2"
import script from "./noticeUserPop.vue?vue&type=script&lang=js"
export * from "./noticeUserPop.vue?vue&type=script&lang=js"
import style0 from "./noticeUserPop.vue?vue&type=style&index=0&id=4e8c12f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports